export const passwordConstants = {
  CHANGE_PASSWORD_SUCCESS: 'SEND_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_REQUEST: 'SEND_PASSWORD_REQUEST',
  CHANGE_PASSWORD_FAILURE: 'SEND_PASSWORD_FAILURE',
  CHANGE_PASSWORD_CANCEL: 'SEND_PASSWORD_CANCEL',
};
